<div class="ui-g ui-fluid">
  <div class="ui-g-12 ui-lg-12">
    <div class="card card-w-title">
      <h2 class="first">Manage Organisation Structure</h2>
      <div *ngIf="customerorgId > 0">
        <p-tabView (onChange)="tabChange($event)">
          <p-tabPanel
            header="Departments and Teams"
            *ngIf="customerorgId == 2 || customerorgId == 4"
            [selected]="tabIndex === 0"
          >
            <org-structure [org_type]="'customer'"></org-structure>
          </p-tabPanel>
          <p-tabPanel
            header="Regions and Depots"
            *ngIf="customerorgId == 3 || customerorgId == 4"
            [selected]="tabIndex === 1"
          >
            <org-structure [org_type]="'supplier'"></org-structure>
          </p-tabPanel>
        </p-tabView>
      </div>

      <h4 *ngIf="customerorgId == 0">No Organisation Attached to this User</h4>
    </div>
  </div>
</div>
